import { ReactElement, useCallback, useMemo } from 'react';
import { IAuthProviderConfig } from '../../../IAuthProviderConfig.types';
import { TProviders } from '../../../IAuthProviders.types';
import { IAuthProviderUiProps } from '../../../IAuthProviderUiProps.types';
import { ContinueWithVipps } from '../icons/ContinueWithVipps';
import { LoginWithVipps } from '../icons/LoginWithVipps';
import { useVippsProvider } from '../services/useVippsProvider';
import styles from './VippsLogin.module.scss';

export type IVippsLoginProps = IAuthProviderUiProps & {
  onStart?: (provider: TProviders) => void;
  onSuccess: IAuthProviderConfig['onSuccess'];
  onError: IAuthProviderConfig['onError'];
  axoApiUrl: string;
  label?: 'login' | 'continue';
};

export const VippsLogin = (props: IVippsLoginProps): ReactElement => {
  useVippsProvider(props);

  const { onStart, axoApiUrl, label = 'login' } = props;

  const redirectUri = useMemo(() => {
    const url = new URL(window.location.href);

    if (!url.searchParams.has('provider'))
      url.searchParams.set('provider', 'vipps');

    return url.href;
  }, []);

  const authUrl = useMemo(
    () =>
      `${axoApiUrl}/auth/provider/vipps/auth?redirect_uri=${encodeURIComponent(
        redirectUri
      )}`,
    [axoApiUrl, redirectUri]
  );

  const handleLoginStart = useCallback(() => {
    onStart?.(TProviders.Vipps);
  }, [onStart]);

  return (
    <a
      className={styles.vippsLogin}
      onClick={handleLoginStart}
      href={authUrl}
      data-testid="vipps-login"
      target="_self"
      rel="noreferrer"
    >
      <div className={styles.label}>
        {label === 'login' ? <LoginWithVipps /> : <ContinueWithVipps />}
      </div>
    </a>
  );
};
